
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import BackIcon from "../../../../assets/svg/BackIcon";
import { useNavigate } from "react-router-dom";

import AnvioZhandu from "../../../../assets/images/anvio-games/Zhandu.webp";
import AnvioTeenPatti from "../../../../assets/images/anvio-games/teenpatti.webp";
import AnvioDragonTiger from "../../../../assets/images/anvio-games/dragontiger.webp";
import AnvioDana from "../../../../assets/images/anvio-games/dana.webp";
import AnvioRoulette from "../../../../assets/images/anvio-games/Roulette.webp";
import AnvioSevenupDown from "../../../../assets/images/anvio-games/sevenupdown.webp";
import AnvioTeenpatti2 from "../../../../assets/images/anvio-games/Teenpatti2.webp";


const AnvioGames = () => {
  const navigate = useNavigate();
  
  
  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <div className="container">
          <div className="live-deal-section">
            <div className="pagesHeading">
              <h2 className="sectionTitle border-0">Anvio Games</h2>
              <div className="back-link" onClick={() => navigate(-1)}>
                Back <BackIcon />
              </div>
            </div>

            <ul>
              <ul>
                
                <li className="exchangeGames-item">
                  <a href="/casino/anvioanvio-zhandu">
                    <img
                      src={AnvioZhandu}
                      alt="ezugi"
                      className="exchangeGames-img-body"
                    />
                  </a>
                </li>
                <li className="exchangeGames-item">
                  <a href="/casino/anvioanvio-teenpatti">
                    <img
                      src={AnvioTeenPatti}
                      alt="evolution"
                      className="exchangeGames-img-body"
                    />
                  </a>
                </li>
                <li className="exchangeGames-item">
                  <a href="/casino/anvioanvio-dragon-tiger">
                    <img
                      src={AnvioDragonTiger}
                      alt="vivo"
                      className="exchangeGames-img-body"
                    />
                  </a>
                </li>
                <li className="exchangeGames-item">
                  <a href="/casino/anvioanvio-dana">
                    <img
                      src={AnvioDana}
                      alt="xpg"
                      className="exchangeGames-img-body"
                    />
                  </a>
                </li>
                <li className="exchangeGames-item">
                  <a href="/casino/anvioanvio-roulette">
                    <img
                      src={AnvioRoulette}
                      alt="xpg"
                      className="exchangeGames-img-body"
                    />
                  </a>
                </li>
                <li className="exchangeGames-item">
                  <a href="/casino/anvioanvio-7-up-and-down">
                    <img
                      src={AnvioSevenupDown}
                      alt="xpg"
                      className="exchangeGames-img-body"
                    />
                  </a>
                </li>
                <li className="exchangeGames-item">
                  <a href="/casino/anvioanvio-teenpatti2">
                    <img
                      src={AnvioTeenpatti2}
                      alt="xpg"
                      className="exchangeGames-img-body"
                    />
                  </a>
                </li>
              </ul>
            </ul>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default AnvioGames;
